import styles from './index.module.scss';
import type { CardItemProps } from './cardItem';
import CardItem from './cardItem';

const Card = ({
  className,
  title,
  description,
  children,
  data,
  onClick,
}: {
  className?: string;
  title?: string;
  description?: React.ReactNode;
  children?: React.ReactNode;
  data?: (CardItemProps & { onClick?: (item: CardItemProps) => void })[];
  onClick?: (item: CardItemProps) => void;
}) => {
  return (
    <div className={cls(styles.card, className)}>
      <div className={styles.title}>{title}</div>
      <div className={styles.content}>
        {data
          ? data.map((item, index) => (
              <CardItem
                {...item}
                key={item.key || index}
                onClick={
                  (onClick || item.onClick) &&
                  (() => {
                    onClick?.(item);
                    item.onClick?.(item);
                  })
                }
              />
            ))
          : children}
      </div>
      {description && <div className={styles.description}>{description}</div>}
    </div>
  );
};

export { Card, CardItem };
